import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import {
    faInbox as faInboxIcon,
    faTasks,
    faBriefcase as faBriefcaseIcon,
    faLayerGroup,
    faClock,
    faCheck,
    faGlobe,
} from '@fortawesome/free-solid-svg-icons';

export type ViewKey = 'inbox' | 'applications' | 'tasks' | 'all';

export type AreaOption = {
    id: string;
    label: string;
};

export type ViewOption = {
    id: ViewKey;
    label: string;
    icon: IconDefinition;
};

export type StateOption = {
    id: string;
    label: string;
    icon: IconDefinition;
};

export const BASE_AREAS: AreaOption[] = [
    { id: 'all', label: 'All Areas' },
    { id: 'job_hunt', label: 'Job Search' },
    { id: 'parenthood', label: 'Parenthood' },
    { id: 'business', label: 'Business' },
    { id: 'finance', label: 'Finance' },
    { id: 'general', label: 'General' },
];

export const VIEWS: ViewOption[] = [
    { id: 'inbox', label: 'Inbox', icon: faInboxIcon },
    { id: 'applications', label: 'Applications', icon: faBriefcaseIcon },
    { id: 'tasks', label: 'Tasks', icon: faTasks },
    { id: 'all', label: 'All Items', icon: faLayerGroup },
];

export const STATES: StateOption[] = [
    { id: 'ACTIVE,TRIAGE', label: 'Open', icon: faClock },
    { id: 'DONE', label: 'Done', icon: faCheck },
    { id: 'ALL', label: 'All', icon: faGlobe },
];
